module.exports = __webpack_public_path__ + "img/nt55-04-80-1.prt.b8e0aded.jpg";